import React, {Component} from 'react';

export default class Texto40 extends Component {
  render() {
    return (
      <section className="padraoNacional py-4" id='padraoNacional'>
        <div className="meiaentrada-title mb-5">
          <div className="container">
            <div className="meiaentrada-title-border-hide">
              <h1>Cumprimento da cota dos 40% dos ingressos</h1>
            </div>
          </div>
        </div>
        <div className="container">
          <p>
            Os estabelecimentos devem reservar 40% dos ingressos para venda aos estudantes e outros
            beneficiários da meia-entrada (idosos, pessoas com deficiência e jovens de 15 a 29 anos
            comprovadamente carentes), até 48 horas antes do início do evento, ou até 72 horas antes do
            evento no caso de eventos realizados em estabelecimentos com capacidade superior a 10 mil
            pessoas, em todos os pontos de venda de ingresso, físicos ou virtuais.
          </p>
          <p>
            Mesmo que haja lugares disponíveis, quando o percentual destinado à meia-entrada se
            esgotar, o estudante não terá mais direito a pagar metade do valor do ingresso.
            Não é possível acumular a meia-entrada com outras promoções, convênio ou vantagens
            vinculadas à aquisição do ingresso por associado de entidade esportiva, como sócio-torcedor,
            descontos promocionais e similares. Esses ingressos não serão considerados no cálculo do
            percentual de 40%.
          </p>
          <p>
            Esta cota deve ser aplicada a todas as categorias de ingressos disponíveis para venda ao
            público como camarotes, área e cadeiras especiais, se vendidos de forma individual e pessoal;
            a redução contará apenas no valor da entrada e não nos serviços que possam ser oferecidos
            nestes setores. O desconto de 50% não será cumulativo com outros oferecidos por leis
            estaduais ou municipais.
          </p>
        </div>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/views/Texto40/Texto40.js